// extracted by mini-css-extract-plugin
export default {"aboutUs":"about_aboutUs__W7uT5","leftAbout":"about_leftAbout__FaY3Z","glow":"about_glow__g3-G4","rightAbout":"about_rightAbout__ExDM4","desc":"about_desc__aS8En"};